import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Breadcrumb.module.css';
import { useNavigation } from '../../context/NavigationContext ';

export default function Breadcrumb() {
  const { breadcrumbs, truncateBreadcrumbsTo } = useNavigation();

  const handleBreadcrumbClick = (index) => {
    truncateBreadcrumbsTo(index);
  };

  return (
    <div className={styles.breadcrumb}>
      {breadcrumbs.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <span className={styles.separator}> &gt; </span>}
          <Link 
            to={item.path} 
            className={styles.breadcrumbItem}
            onClick={() => handleBreadcrumbClick(index)}
          >
            {item.label}
          </Link>
        </React.Fragment>
      ))}
    </div>
  );
}